import { useQuery } from '@tanstack/react-query';
import { teamApi } from '@/lib/api';

export function useTeamMembers() {
  return useQuery({
    queryKey: ['team', 'members'],
    queryFn: () => teamApi.getMembers(),
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
  });
}
